// 处理 情报/攻略 文本类型文章中链接使用内置浏览器打开
export const handleTextArticle = (text) => {
  const el = document.createElement('div');
  el.innerHTML = text;
  const aEl = el.getElementsByTagName('a');
  
  if (!aEl.length) {
    return text
  } else {
    for(let i = 0; i < aEl.length; i++) {
      aEl[i].dataset.href = aEl[i].href;
      aEl[i].href = "javaScript:;";
    }
    return el.innerHTML;
  }
}